export default __webpack_public_path__ + "static/media/Lava 1.eefca4ab.png";